import { Injectable } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Observable } from 'rxjs';
import { PopupMessageComponent } from '../components/popup-message/popup-message.component';

@Injectable({ providedIn: 'root' })
export class ModalService {
  bsModalRef!: BsModalRef;
  constructor(private bsModalService: BsModalService) {}

  confirm(popupDisplayObj: any, className?: string) {
    const initialState = {
      popupDisplayObj: popupDisplayObj,
    } as Partial<PopupMessageComponent>;
    this.bsModalRef = this.bsModalService.show(PopupMessageComponent, { initialState, backdrop: 'static' });
    if (className) {
      this.bsModalRef.setClass(className);
    }
    return new Observable<string[]>(this.getConfirmSubscriber());
  }

  private getConfirmSubscriber() {
    return (observer: any) => {
      const subscription = this.bsModalService.onHidden.subscribe((reason: string[]) => {
        observer.next(this.bsModalRef.content.popupCallbackDetail);
        observer.complete();
      });

      return {
        unsubscribe() {
          subscription.unsubscribe();
        },
      };
    };
  }
}
